import type { MfaResponse } from "#app/_api/bol-authentication-service/model-types";

export function cacheWidgetMfaSession(mfaSession: MfaResponse) {
  localStorage.setItem("widgetMfaSession", JSON.stringify(mfaSession));
}

export function removeWidgetMfaSession() {
  localStorage.removeItem("widgetMfaSession");
}

export function getWidgetMfaSession(): MfaResponse | null {
  const session = localStorage.getItem("widgetMfaSession");
  if (session == null) {
    return null;
  }
  return JSON.parse(session) as MfaResponse;
}

/* export const widgetMfaPageStateMapping = {
  Mfaing: 0,
  ViewPage: 1,
  Errored: 2,
} as const; */
